import styled from '@emotion/styled'
import { stylesIf, themeColor } from 'utils/styles'
import { isString } from 'utils/types'
import Icon from 'components/patterns/Icon'
import { Menu } from 'antd'

const withStyle = (DropdownMenu) =>
  styled(DropdownMenu)(
    (props) => `
        ul{
         margin-top:3px;
        }
      `
  )

export const MenuItem = styled(Menu.Item)((props) => {
  const { type, disabled, theme, children } = props
  const {
    linkDarkColor,
    iconLinkColor,
    iconLinkHover,
    btnTertiaryHoverColor,
    buttonPrimaryColor,
  } = theme

  const dangerStyles = stylesIf(
    type === 'danger',
    `
    &:hover {
      color: ${buttonPrimaryColor};
      background: ${btnTertiaryHoverColor};
      ${Icon} path {
        fill: ${buttonPrimaryColor}
      }
    }
  `
  )

  const spacing = isString(children)
    ? 'padding: 5px 12px;'
    : `
      >* {
        padding: 5px 12px;
      }
    `

  /* eslint-disable indent */
  return `
    padding: 0;
    color: ${linkDarkColor};

    ${Icon} path {
      transition: fill .3s;
      fill: ${iconLinkColor};
    }

    ${stylesIf(
      !disabled,
      `&:hover {
        ${Icon} path {
          fill: ${iconLinkHover};
        }
      }`
    )}
    ${spacing}
    ${dangerStyles}
  `
})

export const Message = styled(MenuItem)`
  color: ${themeColor('paragraphColor')};
`

export const SubMenu = styled(Menu.SubMenu)`
  color: ${themeColor('linkDarkColor')};

  .ant-dropdown-menu-submenu-title {
    color: ${themeColor('linkDarkColor')};
    svg {
      fill: ${themeColor('linkDarkColor')};
    }
  }
`

export default withStyle
